import axios from 'axios';
import React, {useEffect, useState, useMemo} from 'react'
import {loadStripe} from '@stripe/stripe-js';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Loader from '../../utils/Loader';
import DataTable from './DataTable'
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./MainTable.css"
import BigNumber from 'bignumber.js'
import sound_1 from "../../../Alerts/sound_1.mp3"
import sound_2 from "../../../Alerts/sound_2.mp3"
import sound_3 from "../../../Alerts/sound_3.mp3"
import sound_4 from "../../../Alerts/sound_4.mp3"
import sound_5 from "../../../Alerts/sound_5.mp3"
import sound_6 from "../../../Alerts/sound_6.mp3"
import sound_7 from "../../../Alerts/sound_7.mp3"
import sound_8 from "../../../Alerts/sound_8.mp3"
import sound_9 from "../../../Alerts/sound_9.mp3"
import sound_10 from "../../../Alerts/sound_10.mp3"
import sound_11 from "../../../Alerts/sound_11.mp3"
import sound_12 from "../../../Alerts/sound_12.mp3"

const {URL_1MIN_USDT, URL_3MIN_USDT, URL_SECONDS_SPOT, URL_1MIN_SPOT, URL_3MIN_SPOT} = require('./Symbols_Data')

function MainTable() {

  const [alert, setAlert] = useState({ c10s:false, c20s:false, c30s:false, c1m:false, c3m:false, c5m:false, 
    c1h:false, c2h:false, c3h:false, c4h:false, c1d:false, c7d:false, c30d:false, c1y:false})

  const user = JSON.parse(localStorage.getItem('login'))
  let timeSendMail = '1671989426000'

  const [subscribed, setSubscribed] = useState(false)

  const [searchText, setSearchText] = useState("")

  const [loading, setLoading] = useState(true)
  const [dataType, setDataType] = useState(JSON.parse(localStorage.getItem('dataType')))

  const [activeAlert, setActiveAlert] = useState(false)
  const [percentages, setPercentages] = useState([]) // {symbol: , symbol_name: , price: , usd10s: , usd5min: ,  }

  const [AlertFile, setAlertFile] = useState(sound_1)
  let audioAlert1 = useMemo(() => new Audio(sound_1), [AlertFile]);
  let audioAlert2 = useMemo(() => new Audio(sound_2), [AlertFile]);
  let audioAlert3 = useMemo(() => new Audio(sound_3), [AlertFile]);
  let audioAlert4 = useMemo(() => new Audio(sound_4), [AlertFile]);
  let audioAlert5 = useMemo(() => new Audio(sound_5), [AlertFile]);
  let audioAlert6 = useMemo(() => new Audio(sound_6), [AlertFile]);
  let audioAlert7 = useMemo(() => new Audio(sound_7), [AlertFile]);
  let audioAlert8 = useMemo(() => new Audio(sound_8), [AlertFile]);
  let audioAlert9 = useMemo(() => new Audio(sound_9), [AlertFile]);
  let audioAlert10 = useMemo(() => new Audio(sound_10), [AlertFile]);
  let audioAlert11 = useMemo(() => new Audio(sound_11), [AlertFile]);
  let audioAlert12 = useMemo(() => new Audio(sound_12), [AlertFile]);

  var Last10s = []
  var countLast10s = -1
  
  var Last20s = []
  var countLast20s = -1

  var Last30s = []
  var countLast30s = -1


  // GET ALL COINS SYMBOLS AND PRICES
  useEffect(async () => {

    if(user.billingID){
        const res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/payment/checkSubscription', { billingId: user.billingID, email: user.email })
        if(res.data === true) {
            setSubscribed(res.data)
        }
    }
    // Initialisation on the Table from QuantifyCrypto
    initData()
    setLoading(false)
    getPercentages()

    // Handle the seconds column & the prices with Binance Websocket
    if(dataType === "SPOT"){

      setInterval(async () => { await getSecondsPercentages_SPOT(URL_SECONDS_SPOT) }, 2000);
      get1Minute(URL_1MIN_SPOT, 'USD', 'BUSD')
      get3Minute(URL_3MIN_SPOT, 'USD', 'BUSD')

    }else{

      getSecondsPercentages_USDT()
      get1Minute(URL_1MIN_USDT, 'USDT')
      get3Minute(URL_3MIN_USDT, 'USDT')

    }

  }, [])


  const initData = async () => {
    try {
      if(dataType === "SPOT"){
        const res = await axios.get('https://iq-screener-backend-a7au.vercel.app/api/crypto/init-table/SPOT')
        setPercentages(res.data)
      }else{
        const res = await axios.get('https://iq-screener-backend-a7au.vercel.app/api/crypto/init-table/USDT')
        setPercentages(res.data)
      }
    }
    catch (err) {
      toast.error('Error', { containerId:'DisplayInfo', theme: "colored" })
    }

  }

  const getPercentages = () => {
    const baseURL = "https://eventstream.quantifycrypto.com/ptc-change-broadcast";
    const source = new EventSource(baseURL)
    source.onmessage = e => {

      let data = JSON.parse(e.data)
      let Alert = localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {}

      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if (obj.symbol === data.qc_key) {
            if(data.change_usd_5min){
              checkForAlert('c5m', obj.symbol, data.change_usd_5min, '5 minutes', Alert)
              return {...obj, usd5min: data.change_usd_5min};
            }
            else if(data.change_usd_1h){
              checkForAlert('c1h', obj.symbol, data.change_usd_1h, '1 hour', Alert)
              return {...obj, usd1h: data.change_usd_1h};
            }
            else if(data.change_usd_2h){
              checkForAlert('c2h', obj.symbol, data.change_usd_2h, '2 hours', Alert)
              return {...obj, usd2h: data.change_usd_2h};
            }
            else if(data.change_usd_4h){
              checkForAlert('c4h', obj.symbol, data.change_usd_4h, '4 hours', Alert)
              return {...obj, usd4h: data.change_usd_4h};
            }
            else if(data.change_usd_24h){
              checkForAlert('c1d', obj.symbol, data.change_usd_24h, '1 day', Alert)
              return {...obj, usd1d: data.change_usd_24h};
            }
            else if(data.change_usd_7d){
              checkForAlert('c7d', obj.symbol, data.change_usd_7d, '1 week', Alert)
              return {...obj, usd7d: data.change_usd_7d};
            }
            else if(data.change_usd_30d){
              checkForAlert('c30d', obj.symbol, data.change_usd_30d, '1 month', Alert)
              return {...obj, usd30d: data.change_usd_30d};
            }
            else if(data.change_usd_1year){
              checkForAlert('c1y', obj.symbol, data.change_usd_1year, '1 year', Alert)
              return {...obj, usd1y: data.change_usd_1year};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });

    }
  }

  const get1Minute = (url, suffix1, suffix2) => {
    let connection1minute = new WebSocket(url);
    connection1minute.onmessage = evt => { 
      let Alert = localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {}
      let data = JSON.parse(evt.data).data.k
      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if ((obj.symbol+suffix1 === data.s) || (obj.symbol+suffix2 === data.s)) {
            let percent = ((data.c-data.o)/data.c)
            
            if(percent !== 0){
              // ALERT 
              checkForAlert('c1m', obj.symbol, percent, '1 minute', Alert)

              return {...obj, usd1min: percent};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });
    }

    connection1minute.onerror = evt => {
        console.error(evt);
    }

    return () => {connection1minute.close();}

  }

  const get3Minute = (url, suffix1, suffix2) => {

    let connection = new WebSocket(url);
    connection.onmessage = evt => { 
      let Alert = localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {}
      let data = JSON.parse(evt.data).data.k
      setPercentages(prevState => {
        const newState = prevState.map(obj => {

          // if the symbol exist in the table
          if ((obj.symbol+suffix1 === data.s) || (obj.symbol+suffix2 === data.s)) {
            let percent = ((data.c-data.o)/data.c)
            if(percent !== 0){
              // ALERT
              checkForAlert('c3m', obj.symbol, percent, '3 minutes', Alert)
              
              return {...obj, usd3min: percent};
            }
          }

          // otherwise return object as is
          return obj;
        });

        return newState;
      });
    }

    connection.onerror = evt => {
        console.error(evt);
    }

    return () => {connection.close();}

  }
  
  const getSecondsPercentages_USDT = () => {
    let connection = new WebSocket(`wss://fstream.binance.com/ws/!markPrice@arr@1s`);
    connection.onmessage = evt => { 
      let Alert = localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {}

      countLast10s++ 
      if(countLast10s === 10 ){
        countLast10s = 0
      }

      // Start Calculating the Percentages after 10s
      if(Last10s.length === 10){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data10s = Last10s[countLast10s].findIndex(data => data.s === obj.symbol + 'USDT');

            // if the symbol exist in the table
            if(data10s !== -1){
              let oldPrice = Last10s[countLast10s][data10s].p
              let newPrice = JSON.parse(evt.data)[data10s].p
              let percent = ((newPrice-oldPrice)/newPrice)
              // ALERT 
              checkForAlert('c10s', obj.symbol, percent, '10 Seconds', Alert)

              // RETURN 
              return {...obj, usd10s: percent, price: newPrice };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      } // Update the price
      else{
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            if(Last10s[0]){
              let data10s = Last10s[0].findIndex(data => data.s === obj.symbol + 'USDT');

              // if the symbol exist in the table
              if(data10s !== -1){
                // RETURN 
                return {...obj, price: JSON.parse(evt.data)[data10s].p };
              }
            }
            
            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      }
      // Collect Last 10 seconds 
      Last10s[countLast10s] = JSON.parse(evt.data)


      countLast20s++ 
      if(countLast20s === 20 ){
        countLast20s = 0
      }

      // Start Calculating the Percentages after 20s
      if(Last20s.length === 20){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data20s = Last20s[countLast20s].findIndex(data => data.s === obj.symbol + 'USDT');

            if(data20s !== -1){
              let oldPrice = Last20s[countLast20s][data20s].p
              let newPrice = JSON.parse(evt.data)[data20s].p
              let percent = ((newPrice-oldPrice)/newPrice)
              // ALERT 
              checkForAlert('c20s', obj.symbol, percent, '20 Seconds', Alert)

              // RETURN 
              return {...obj, usd20s: percent };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      }
      // Collect Last 20 seconds
      Last20s[countLast20s] = JSON.parse(evt.data)


      countLast30s++ 
      if(countLast30s === 30 ){
        countLast30s = 0
      }

      // Start Calculating the Percentages after 30s
      if(Last30s.length === 30){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data30s = Last30s[countLast30s].findIndex(data => data.s === obj.symbol + 'USDT');

            if(data30s !== -1){
              let oldPrice = Last30s[countLast30s][data30s].p
              let newPrice = JSON.parse(evt.data)[data30s].p
              let percent = ((newPrice-oldPrice)/newPrice)
              // ALERT 
              checkForAlert('c30s', obj.symbol, percent, '30 Seconds', Alert)

              // RETURN
              return {...obj, usd30s: percent };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      }
      // Collect Last 30 seconds
      Last30s[countLast30s] = JSON.parse(evt.data)

    }

    connection.onerror = evt => {
        console.error(evt);
    }

    return () => {connection.close();}

  }

  const getSecondsPercentages_SPOT = async (URL) => {

    try {

      let Alert = localStorage.getItem('dataAlert') ? JSON.parse(localStorage.getItem('dataAlert')) : {}
      let res = await axios.get(URL)

      countLast10s++ 
      if(countLast10s === 10 ){
        countLast10s = 0
      }

      if(Last10s.length === 10){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data10s = Last10s[countLast10s].findIndex(data => (data.symbol === obj.symbol + 'USD') || (data.symbol === obj.symbol + 'BUSD'));

            // if the symbol exist in the table
            if(data10s !== -1){
              let oldPrice = Last10s[countLast10s][data10s].price
              let newPrice = res.data[data10s].price
              let percent = ((newPrice-oldPrice)/newPrice)

              // ALERT 
              checkForAlert('c10s', obj.symbol, percent, '10 Seconds', Alert)

              return {...obj, usd10s: percent, price: newPrice };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      } // Update the price
      else{
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            if(Last10s[0]){
              let data10s = Last10s[0].findIndex(data => (data.symbol === obj.symbol + 'USD') || (data.symbol === obj.symbol + 'BUSD'));

              // if the symbol exist in the table
              if(data10s !== -1){
                // RETURN 
                return {...obj, price: res.data[data10s].price };
              }
            }
            
            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      }
      // Collect Last 10 seconds 
      Last10s[countLast10s] = res.data


      countLast20s++ 
      if(countLast20s === 20 ){
        countLast20s = 0
      }

      // Start Calculating the Percentages after 20s
      if(Last20s.length === 20){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data20s = Last20s[countLast20s].findIndex(data => (data.symbol === obj.symbol + 'USD') || (data.symbol === obj.symbol + 'BUSD'));

            // if the symbol exist in the table
            if(data20s !== -1){
              let oldPrice = Last20s[countLast20s][data20s].price
              let newPrice = res.data[data20s].price
              let percent = ((newPrice-oldPrice)/newPrice)

              // ALERT 
              checkForAlert('c20s', obj.symbol, percent, '20 Seconds', Alert)

              return {...obj, usd20s: percent, price: newPrice };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      } 
      // Collect Last 20 seconds
      Last20s[countLast20s] = res.data


      countLast30s++ 
      if(countLast30s === 30 ){
        countLast30s = 0
      }

      // Start Calculating the Percentages after 30s
      if(Last30s.length === 30){
        setPercentages(prevState => {
          const newState = prevState.map(obj => {
            let data30s = Last30s[countLast30s].findIndex(data => (data.symbol === obj.symbol + 'USD') || (data.symbol === obj.symbol + 'BUSD'));

            // if the symbol exist in the table
            if(data30s !== -1){
              let oldPrice = Last30s[countLast30s][data30s].price
              let newPrice = res.data[data30s].price
              let percent = ((newPrice-oldPrice)/newPrice)

              // ALERT 
              checkForAlert('c30s', obj.symbol, percent, '30 Seconds', Alert)

              return {...obj, usd30s: percent, price: newPrice };
            }

            // 👇️ otherwise return object as is
            return obj;
          });
  
          return newState;
        });
      } 
      // Collect Last 30 seconds
      Last30s[countLast30s] = res.data

    }
    catch (err) {
      toast.error('Error', { containerId:'DisplayInfo', theme: "colored" })
    }
    
  }

  
  // Column:c5m, symbol:pbj.Symbol = BTC, newPercent:percent, lastX: 5 
  const checkForAlert = (column, symbol, newPercent, lastX, Alert) =>{
    if(Alert[column] && ((Alert[column].gt <= newPercent*100 ) || (Alert[column].lt >= newPercent*100))){
      let message = '(' + symbol + `) Last ${lastX} = ` + new BigNumber(newPercent*100).toFormat(2,1) + ' %'
      runAlert(message, symbol+column, Alert[column].sound, Alert[column].emailNotif)
    }

  }

  const runAlert = async (text, customId, sound, emailNotif) => {
    let timeSpace = (Date.now() - timeSendMail)/1000
    if(emailNotif && (timeSpace>60)){
      timeSendMail = Date.now()
      let details = 'Alert Description...'
      const res = await axios.post('https://iq-screener-backend-a7au.vercel.app/api/crypto/sendAlert', { name: user.name, email: user.email, details })
    }

    setActiveAlert(true)

    toast.info(text, { containerId:'CoinsAlert', toastId: customId, theme: "colored" })
    switch(sound){
      case "sound_1":
        audioAlert1.play()
        break;
      case "sound_2":
        audioAlert2.play()
        break;
      case "sound_3":
        audioAlert3.play()
        break;
      case "sound_4":
        audioAlert4.play()
        break;
      case "sound_5":
        audioAlert5.play()
        break;
      case "sound_6":
        audioAlert6.play()
        break;
      case "sound_7":
        audioAlert7.play()
        break;
      case "sound_8":
        audioAlert8.play()
        break;
      case "sound_9":
        audioAlert9.play()
        break;
      case "sound_10":
        audioAlert10.play()
        break;
      case "sound_11":
        audioAlert11.play()
        break;
      case "sound_12":
        audioAlert12.play()
        break;
      default:
        audioAlert1.play()
        break;
    }

  }

  const handleDeleteAlert = () => {
    toast.dismiss();
    setActiveAlert(false)
  }

  const handleStopAlert = () => {
    localStorage.setItem('dataAlert', JSON.stringify({}));

    setAlert({ c10s:false, c20s:false, c30s:false, c1m:false, c3m:false, c5m:false, 
      c1h:false, c2h:false, c3h:false, c4h:false, c1d:false, c7d:false, c30d:false, c1y:false})
  }

  const handleChange = (e) => {
    const { id, value } = e.target
    localStorage.setItem('dataType', JSON.stringify(value));
    window.location.reload(false);
  }

  const handleSearch = (e) => {
    setSearchText(e.target.value)
  }


  return (
    <div className="container-fluid">
      {
        loading ? <Loader/>:    
        <React.Fragment>
          <div className='top-table mb-3 '>
            <Form.Select className="mr-3" id="dataType" onChange={handleChange}>
              <option value="USDT" selected={dataType === "USDT"}>Futures USDT (Binance)</option>
              <option value="SPOT" selected={dataType === "SPOT"}>SPOT</option>
            </Form.Select>
    
            <Form.Group className="d-flex justify-content-center" controlId="formBasicPassword">
              <input type="text" placeholder="Search ..." id="search" name="search" 
              onChange={handleSearch} className="searchInput label-input form-control"/>   
            </Form.Group>
          </div>
  
          <div className="row">
              <div className="col-12">
                <DataTable percentages={percentages} subscribed={subscribed} alert={alert} setAlert={setAlert} searchText={searchText}/>
              </div>
          </div>

          <div className='Alert-Modal'>
            <Alert show={activeAlert} variant="dark">
              <div className="alert-settings d-flex justify-content-between align-items-center">
                <Button onClick={() => handleStopAlert()} size="sm" variant="outline-danger">
                  Disable All
                </Button>
                <Button onClick={() => handleDeleteAlert()} size="sm" variant="outline-secondary">
                  Hide All
                </Button>
              </div>
            </Alert>
          </div>
        </React.Fragment>
      }
    </div> 
  )
}

export default MainTable